module.exports = __webpack_public_path__ + "static/media/wave.eb373e5d.png";